import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./English.css";

function English() {
  const [userGrade, setUserGrade] = useState(null);

  useEffect(() => {
    const userAge = parseInt(localStorage.getItem("userAge"), 10);
    if (userAge && userAge >= 6 && userAge <= 18) {
      setUserGrade(userAge - 5);
    }
  }, []);

  const gradeList = userGrade
    ? [
        <Link
          key={userGrade}
          to={`/English/grade${userGrade}`}
          className="English-grade-card"
        >
          Grade {userGrade}
        </Link>,
      ]
    : [...Array(12)].map((_, index) => (
        <Link
          key={index + 1}
          to={`/English/grade${index + 1}`}
          className="English-grade-card"
        >
          Grade {index + 1}
        </Link>
      ));

  // Show poetry/shakespeare for grade 8 and up or always (adjust as needed)
  const showPoetry = !userGrade || userGrade >= 8;
  const showShakespeare = !userGrade || userGrade >= 8;

  return (
    <div className="play2learn-English">
      <h1 className="English-title">English Lessons</h1>
      <p className="English-description">
        {userGrade
          ? `Showing content for Grade ${userGrade}`
          : "Select a grade to start learning:"}
      </p>

      {/* Grade Selection */}
      <div className="English-grade-container">{gradeList}</div>

      {/* --- Poetry and Shakespeare Modules --- */}
      {(showPoetry || showShakespeare) && (
        <div className="English-special-modules" style={{ marginTop: 32 }}>
          <h2>Advanced & Enrichment Modules</h2>
          {showPoetry && (
            <Link to="/english/poetry" className="English-grade-card special">
              Poetry & Literary Devices
            </Link>
          )}
          {showShakespeare && (
            <Link to="/english/shakespeare" className="English-grade-card special">
              Shakespeare & Drama
            </Link>
          )}
        </div>
      )}

      <div className="English-practice-section">
  <div className="English-practice-title">Practice Your English</div>
  <div className="English-practice-buttons">
    <Link to="/english/practice/spelling" className="practice-btn">
      📝 Spelling Practice
    </Link>
    <Link to="/english/practice/unscramble" className="practice-btn">
      🧩 Sentence Unscramble
    </Link>
    <Link to="/english/practice/listening" className="practice-btn">
      🎧 Listening Practice
    </Link>
    <Link to="/english/practice/flashcards" className="practice-btn">
      🎧 Flash Cards Game
    </Link>
  </div>
</div>

    </div>
  );
}

export default English;
